import { rest } from 'msw'
import * as Products from './resolvers/products'
import * as Timelines from './resolvers/timelines'
import * as Validation from './resolvers/validation'
import * as Promotions from './resolvers/promotions'
import * as Permissions from './resolvers/permissions'
import { FLAG_ENABLE_MOCK_PERMISSION } from 'core/common/constants/env'

export const handlers = !FLAG_ENABLE_MOCK_PERMISSION
  ? [
      rest.get('*/v1/products', Products.mockBrowse),
      rest.get('*/v1/products/history', Timelines.mockReadTimeline),
      rest.get('*/v1/products/validation/message', Validation.mockReadValidation),
      rest.get('*/v1/products/alerts', async (req, res, ctx) => res(ctx.json([]))),
      rest.get('*/v1/promotions/promo3p/:id', Promotions.mockPromotions),
      rest.get('*/v1/products/:id', Products.mockById),
      rest.get('*/v1/products/:id', Products.mockById),
    ]
  : [rest.get('*/v2/auth/permissions', Permissions.mockPermissions)]
